<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/knowledge/knowledge-list' }">知识库管理</el-breadcrumb-item>
          <el-breadcrumb-item >新增知识库</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="equip-add">
      <dv-border-box-12>
        <div style="padding: 6px 6px 40px 6px;">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">新增知识库</div>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="100px"
            class="add-form"
            :rules="rules"
            ref="form">
            <el-form-item  label="选择文件" prop="fileKey">
              <!-- <div></div> -->
              <el-input id="fileKey" v-model="form.fileKey" :readonly="true" style="width:50%;float:left;margin-right: 10px;"></el-input>
              <el-upload
                class="upload-demo"
                ref="upload"
                action="#"
                accept=".pdf, .png, .jpg, .jpeg, .mp4"
                :auto-upload="true"
                :on-change="checkType">
                <el-button class="action-button-addd" slot="trigger" size="small" type="primary">请从本地选取文件</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="文件名称" prop="filename" style="margin-top: 50px;">
              <el-input id="filename" v-model="form.filename" placeholder="" ></el-input>
            </el-form-item>
            <el-form-item label="文件类型" prop="fileType" style="margin-top: 36px;" class="error">
              <el-input id="fileType" v-model="form.fileType" placeholder="" :readonly="true" >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="action-button" @click="submitForm('form')">立即保存</el-button>
            </el-form-item>
          </el-form>

        </div>
      </dv-border-box-12>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
          form:{
            filename:'',
            fileKey:'',
            fileType:''
          },
          rules: {
            fileKey: [{ required: true, message: '请选择上传文件', trigger: 'blur' }],
            filename: [{ required: true, message: '请填写文件名称', trigger: 'blur' }],
            fileType: [{ required: true, message: '文件类型自动识别，无需手动输入', trigger: 'blur' }]
          },
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addOneKnowledge()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      addOneKnowledge(){

        const headers = {
            'Authorization': localStorage.getItem('token'),
        }
        const url = '/knowledge/add';

        var type = 1
        if (this.form.fileType=='png' || this.form.fileType=='jpg' || this.form.fileType=='jpeg') {
          type = 1
        } else if(this.form.fileType=='avi' || this.form.fileType=='wmv' || this.form.fileType=='mov' || this.form.fileType=='mpg' || this.form.fileType=='mpeg' || this.form.fileType=='flv' || this.form.fileType=='mp4' || this.form.fileType=='swf' || this.form.fileType=='rm' || this.form.fileType=='ram'  ){
          type = 2
        }else{
          type=3
        }

        const data = {
          'fileType':type,
          'filename':this.form.filename,
          'fileKey':this.form.fileKey
        }

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'新增成功',
                type:'success'
              });
              this.resetForm('form')
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      checkType(item){
        const headers = {
          'Authorization': localStorage.getItem('token'),
          'Content-type':'multipart/form-data',
        };
        const url = '/knowledge/upload'
        const formData = new FormData()
        formData.append('file',item.raw);

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:formData
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.fileKey){
                this.form.fileKey = obj.data.fileKey;

                let array = item.name.split('.');
                let fileType = array[array.length-1];
                let filename = array[0]
                this.form.fileType = fileType;
                this.form.filename = filename;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },

      goBack(){
        this.$router.back()
      }
    },
    created() {
    }
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;


    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }


    .equip-add{
      width: 100%;

      .el-upload-list__item{
        color: #fff;
      }


      .action-button-addd{
          width: 200px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,144,255,0.84);
          // border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
      }



      .action-button{
          width: 120px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
      }

      .add-form{
        padding: 25px 5px 25px 0px;

        // 选中前后的文字颜色
        .redbox .el-checkbox__input+.el-checkbox__label{
          color: rgba(255, 255, 255, 0.5);
        }
        .redbox .el-checkbox__input.is-checked+.el-checkbox__label{
          color: #FF8400;
        }

        //选中前后的边框颜色
        .redbox.is-bordered{
          border-color: rgba(255, 255, 255, 0.5);
        }
        .redbox.is-bordered.is-checked{
          border-color: #FF8400;
        }

        // 选中前后对勾框的边框和背景色
        .redbox .el-checkbox__input .el-checkbox__inner, .redbox .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          border-color: #A5D5FF;
          background-color: rgba(255, 255, 255, 0.5);
        }
        .redbox .el-checkbox__input.is-checked .el-checkbox__inner, .redbox .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          border-color: #FF8400;
          background-color: #FF8400;
        }

        .group-box{
          border-radius: 5px;
          border: 1px #20478D solid;
          padding: 10px;
        }
      }
    }

    .el-upload-dragger{
      background-color: #1A3F81;
    }

    .el-upload__tip{
      color: #fff;
    }

    .el-upload-list__item{
      color: #fff;
    }

    .el-upload-list__item.is-error{
      color: red;
    }


  }
</style>



// WEBPACK FOOTER //
// src/view/manage/knowledge/knowledge-add.vue